import React, { useEffect, useState } from "react";
import { useNavigate ,useLocation} from "react-router-dom"; 
import "./checkout.css";

const ProgressTracker = () => {
  const [activeStep, setActiveStep] = useState(1); 
  const [address, setAddress] = useState(""); 
  const [tempAddress, setTempAddress] = useState("");
  const [deliveryOption, setDeliveryOption] = useState("post"); 
  const [cartItems, setCartItems] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false); 
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate(); 
  const location = useLocation();
   const [message, setMessage] = useState(null);
  const buyNowProduct = location.state?.buyNowProduct;
  

  useEffect(() => {
      if (message) {
        const timer = setTimeout(() => setMessage(null), 5000);
        return () => clearTimeout(timer);
      }
    }, [message]);
  
  useEffect(() => {
    const checkSession = async () => {
      try {
        const configRes = await fetch("/config.json");
        const config = await configRes.json();

        const res = await fetch(`${config.BASE_URL}${config.USER_INFO}`, {
          method: "POST",
          credentials: "include", 
        });
        const data = await res.json();

        if (data.success) {
          setIsLoggedIn(true);
          if (data.is_active) {
            setActiveStep(2);
            if (data.address1) {
              setAddress(data.address1);
              setActiveStep(3);
            }
          }
        } else {
          setIsLoggedIn(false);
          setActiveStep(1);
        }
      } catch (error) {
        console.error("Error checking session:", error);
        setIsLoggedIn(false);
        setActiveStep(1);
      }
    };

    const fetchCartItems = async () => {
      try {

         if (buyNowProduct) {
        setCartItems([buyNowProduct]);
        return;
      }

        const configRes = await fetch("/config.json");
        const config = await configRes.json();

        const res = await fetch(`${config.BASE_URL}${config.GET_CART}`, {
          method: "POST",
          credentials: "include", 
        });
        const data = await res.json();

        if (data.success) {
          setCartItems(data.cart);
        } else {
          setCartItems([]);
        }
      } catch (error) {
        console.error("Error fetching cart:", error);
        setCartItems([]);
      }
    };

    checkSession();
    fetchCartItems();
  }, [buyNowProduct]);

  
useEffect(() => {
  if (isLoggedIn) {
    if (!address) {
      setActiveStep(2); // Force step 2 to add address
    } else if (address && activeStep < 3) {
      setActiveStep(3); // Move to step 3 if address exists
    }
  }
}, [address, isLoggedIn,buyNowProduct]);

  

  const productIds = cartItems.map((item) => item.product_id);

   const handlePayment = async () => {
  try {
    const configRes = await fetch("/config.json");
    const config = await configRes.json();

    const amountInPaise = Math.round(total * 100);

    const response = await fetch(`${config.BASE_URL}${config.CREATE_ORDER}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ amount: amountInPaise }),
      credentials: "include",
    });

    const data = await response.json();
    const { order_id } = data;

    if (!order_id) {
      setMessage("Failed to create Razorpay order");
      return;
    }

    const options = {
      key: "rzp_live_1P7gGwYcHvQ4oz", 
      amount: amountInPaise,
      currency: "INR",
      name: "Robocoupler",
      description: "Course Payment",
      image: "/tm logo.png", 
      order_id: order_id,
      handler: async function (response) {
        const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;

       const purchasedItems = cartItems.map((item) => ({
    product_id: item.product_id,
    quantity: item.quantity
  }));

        const invoiceDetails = {
          items: cartItems.map((item) => ({
            productId: item.product_id,
            title: item.title,
            price: parseFloat(item.price),
            quantity: item.quantity
          })),
          subtotal: subtotal,
          tax: tax,
          total: total
        };

        const verifyRes = await fetch(`${config.BASE_URL}${config.VERIFY_PAYMENT}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            razorpay_payment_id,
            razorpay_order_id,
            razorpay_signature,
             purchased_items: purchasedItems, 
            product_ids: productIds
          }),
        });

        const verifyData = await verifyRes.json();

        if (verifyData.status) {
          setMessage(" Payment verified and order placed!");
        } else {
          setMessage("  Payment verification failed: " + verifyData.message);
        }
      },
      prefill: {
        name: "Customer", 
        email: "customer@example.com",
        contact: "9999999999",
      },
      theme: { color: "#0a7cff" },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  } catch (error) {
    console.error("Payment Error:", error);
    setMessage("Something went wrong. Please try again.");
  }
};


  const steps = ["Login", "Delivery Address", "Confirm Order"];

  // Price breakdown
  const subtotal = cartItems.reduce(
  (sum, item) => sum + (parseFloat(item.price) + parseFloat(item.tax)) * item.quantity,
  0
);
  const tax = subtotal * 0.18; 
  const deliveryCharge = deliveryOption === "post" ? 650 : 0;
  const total = subtotal + tax + deliveryCharge;

  return (
    <div>
      <ol className="progress-tracker">
        {steps.map((step, index) => {
          const stepNum = index + 1;
          return (
            <li
              key={step}
              className={`step ${
                stepNum < activeStep
                  ? "completed"
                  : stepNum === activeStep
                  ? "active"
                  : ""
              }`}
            >
              <span className="step-name">{step}</span>
            </li>
          );
        })}
      </ol>

      {/* Step 1: Not logged in → Show Login CTA */}
      {!isLoggedIn && (
        <div className="login-required">
          <h3>You need to login first to place the order.</h3>
          <button className="login-btn" onClick={() => navigate("/login")}>
            Login to Continue
          </button>
        </div>
      )}

      {/* Step 2: Address */}
      {isLoggedIn && activeStep === 2 && (
        <div className="address-box">
          {address ? (
            <>
              <h3>Confirm Your Address for Delivery</h3>
              <p>{address}</p>
              <button onClick={() => navigate("/account")}>Edit</button>
            </>
          ) : (
            <>
              <h3>Add Address</h3>
              <input
                type="text"
                value={tempAddress}
                onChange={(e) => setTempAddress(e.target.value)}
                placeholder="Enter your address"
              />
              <button
                onClick={() => {
                  if (tempAddress.trim() !== "") {
                    setAddress(tempAddress);
                  }
                }}
              >
                Save Address
              </button>
            </>
          )}

          {/* Navigation buttons */}
          <div className="nav-buttons">
            <button
              onClick={() => setActiveStep(3)}
              className="next-btn"
              disabled={!address && !tempAddress}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Step 3: Confirm Order */}
      {isLoggedIn && activeStep === 3 && (
        <div className="confirm-order">
          <div className="cart-left">
            <h3>Cart Items</h3>
            {cartItems.map((item) => (
              <div key={item.product_id} className="cart-item">
                <span>{item.title} x {item.quantity}</span>
                <span>₹{((parseFloat(item.price) + parseFloat(item.tax)) * item.quantity).toFixed(2)}</span>
              </div>
            ))}
            <hr />
          </div>

          <div className="delivery-right">
            <h3>Delivery Options</h3>
            <label>
              <input
                type="radio"
                name="delivery"
                value="office"
                checked={deliveryOption === "office"}
                onChange={(e) => setDeliveryOption(e.target.value)}
              /> Office (No Delivery Charge)
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="delivery"
                value="post"
                checked={deliveryOption === "post"}
                onChange={(e) => setDeliveryOption(e.target.value)}
              /> Post (₹650)
            </label>
            <hr />

            {/* Price Breakdown */}
            <div className="price-summary">
              <div className="line">
                <span>Subtotal:</span>
                <span>₹{subtotal.toFixed(2)}</span>
              </div>
              <div className="line">
                <span>Tax (18%):</span>
                <span>₹{tax.toFixed(2)}</span>
              </div>
              <div className="line">
                <span>Delivery:</span>
                <span>₹{deliveryCharge}</span>
              </div>
              <hr />
              <div className="line total">
                <strong>Total:</strong>
                <strong>₹{total.toFixed(2)}</strong>
              </div>
            </div>

            {/* Navigation buttons */}
            <div className="nav-buttons">
              <button onClick={() => setActiveStep(2)} className="prev-btn">
                Previous
              </button>
              <button
                onClick={() => setShowPopup(true)}
                className="next-btn"
                disabled={!address || !deliveryOption}
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔹 Confirmation Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <h3>Confirm Your Order</h3>
            <p><strong>Address:</strong> {address || tempAddress}</p>
            <p><strong>Delivery:</strong> {deliveryOption === "post" ? "Post (₹650)" : "Office (Free)"}</p>
            <p><strong>Total:</strong> ₹{total.toFixed(2)}</p>
            <div className="popup-buttons">
              <button onClick={() => setShowPopup(false)} className="cancel-btn">
                Cancel
              </button>
              <button onClick={handlePayment} className="confirm-btn">
                Confirm & Place Order
              </button>
            </div>
          </div>
        </div>
      )}
      {message && (
        <div
          style={{
            position: "fixed",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "15px 20px",
            borderRadius: "12px",
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            color: "black",
            fontSize: "14px",
            fontWeight: "500",
            zIndex: 1000,
            minWidth: "250px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <span>{message}</span>
          <span
            style={{ marginLeft: "15px", cursor: "pointer" }}
            onClick={() => setMessage(null)}
          >
            ×
          </span>
        </div>
      )}
    </div>
  );
};

export default ProgressTracker;
